import { AfterContentInit, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Configuration } from 'src/app/domain/configuration';
import { ProductGroup } from 'src/app/domain/product-group';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { ELIMSService } from 'src/app/services/ELIMS.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ProductGroupService } from 'src/app/services/product-group.service';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { ProductBoxComponent } from 'src/app/tools/ui/product-box/product-box.component';
import * as _ from 'lodash'
import { CoreData } from 'src/app/tools/core-data/core-data';
import { Editor, Toolbar, NgxEditorModule } from 'ngx-editor';
import { DomSanitizer } from '@angular/platform-browser';
import { PreventDoubleClickDirective } from '../../tools/directive/prevent-double-click.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgxColorsModule } from 'ngx-colors';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-config',
    templateUrl: './config.component.html',
    styleUrl: './config.component.scss',
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, FormsModule, MatSlideToggleModule, NgxColorsModule, MatIconModule, MatButtonModule, PreventDoubleClickDirective, NgxEditorModule]
})
export class ConfigComponent implements OnInit, AfterContentInit, OnDestroy {
    Model: Configuration = new Configuration();
    IsCreation: boolean = true;
    keywords: string[] = [];
    formControl = new FormControl(['angular']);
    editor?: Editor;
    toolbar: Toolbar = [
        ['bold', 'italic'],
        ['underline', 'strike'],
        ['text_color', 'background_color'],
        ['align_left', 'align_center', 'align_right', 'align_justify'],
    ];

    constructor(
        private sanitizer: DomSanitizer,
        private coreData: CoreData,
        private dialog: MatDialog,
        private router: Router,
        private route: ActivatedRoute,
        private snackBar: MatSnackBar,
        private productGroupService: ProductGroupService,
        private configurationService: ConfigurationService,
        private ELIMSService: ELIMSService) {

    }

    ngOnInit(): void {
        this.editor = new Editor();
    }

    ngAfterContentInit(): void {
        if (this.route.snapshot.params['configurationCode']) {
            this.IsCreation = false;
            this.Model.Code = this.route.snapshot.params['configurationCode'];
            this.getConfiguration();
        }
    }

    ngOnDestroy(): void {
        this.editor?.destroy();
    }

    getConfiguration() {
        this.configurationService.getConfigurationByCode(this.Model.Code).subscribe(x => {
            this.Model = x;
            this.getLogo(this.Model.Code)
        })
    }

    getLogo(confCode: string) {
        this.configurationService.getLogoByCode(confCode).subscribe(x => {
            this.Model.LogoToBase64 = x;
        })
    }

    openProductDialog() {
        const dialogRef = this.dialog.open(ProductBoxComponent, {
            data: undefined,
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: ProductGroup) => {
            if (result) {
                this.Model.ProductGroupList.push(result)
            }
        });
    }

    // openMultipleUploadDialog() {

    //     const dialogRef = this.dialog.open(MultipleFileUploadBoxDialog, {
    //         data: {},
    //         width: '777px',
    //         disableClose: true
    //     });

    //     dialogRef.afterClosed().subscribe(result => {
    //         if (result) {
    //             NotificationManager.handleSuccess('Logo importées !', this.snackBar);
    //         }
    //     });
    // }

    async onFileFromDragNDrop(event: any) {
        let files = event instanceof FileList ? event : event.files;

        for (let index = 0; index < files.length; index++) {
            const element = files[index];
            this.Model.Logo = element;
        }

        const toBase64 = (file: any) => new Promise<any>((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    
        this.Model.LogoToBase64 = await toBase64(this.Model.Logo);
    }

     getBase64FromLogo() {
        console.log(this.sanitizer.bypassSecurityTrustResourceUrl(this.Model.LogoToBase64))
        return this.sanitizer.bypassSecurityTrustResourceUrl(this.Model.LogoToBase64);
    }

    IsThisConfMine(conf: Configuration) {
        return true
        return this.IsCreation || conf.CreatedByEmail === this.coreData.User?.Email
    }

    CanSave() {
        return this.Model.Name && this.Model.ProductGroupList.length >= 1 && this.IsThisConfMine(this.Model);
    }

    goBack() {
        this.router.navigate([ENavigationRoute.Home]);
    }

    deleteProductGroup(pg: ProductGroup) {
        if (!pg.Code) {
            _.remove(this.Model.ProductGroupList, pg);
            return;
        }
        this.productGroupService.delete(pg.Code).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Groupe de matrice retiré !', this.snackBar);
                _.remove(this.Model.ProductGroupList, pg)
            }
        })
    }

    save() {
        if (!this.CanSave())
            return;

        if (this.IsCreation)
            this.configurationService.create(this.Model).subscribe(x => {
                if (x) {
                    NotificationManager.handleSuccess('Configuration ajoutée !', this.snackBar);
                    this.goBack();
                }
            })

        else {
            this.configurationService.update(this.Model).subscribe(x => {
                if (x) {
                    NotificationManager.handleSuccess('Configuration modifiée !', this.snackBar);
                    this.goBack();
                }
            })
        }
    }
}
